import React, { useRef } from "react";
import { HideComponentWrapper, List, Typography } from "../../components";
import { IPopoverSelect } from "../../models/IPopoverProps";
import { Popover } from "../Popover";
import styles from "../Select/PopupSelect.module.css";

const PopoverSelect: React.FC<IPopoverSelect> = (props: IPopoverSelect) => {
	const viewPopupRef = useRef(null);
	const handleSelectValue = (newValue: any) => {
		props.setValue(newValue);
		if (!props.isMulti) {
			(viewPopupRef?.current as any)?.closePopup();
		}
	};

	return (
		<div style={props.formStyle} className={`${styles.popup_group} ${props.formClass ?? ""}`}>
			<HideComponentWrapper show={!!props.label}>
				<Typography className={`${styles.form_label} ${props.required === true ? styles.required : styles.optional}`}>
					{props.label}
				</Typography>
			</HideComponentWrapper>
			<Popover
				target={props.target}
				ref={props.ref || viewPopupRef}
				parentClass={`${styles.popup_select_cont} ${props.popupParentClass ?? "mt-1"}`}
				handlePopupVisible={props.handlePopupVisible}
				position={props.position || "bottom"}
				parentStyle={props.popupStyle}
				iconContainerClass={props.iconContainerClass}
				dropdownClass={props.dropdownClass}
				disableClick={props.disabled}
			>
				<List options={props.selectOptions} selectedItem={props.value} setSelectedItem={handleSelectValue} />
			</Popover>
		</div>
	);
};

PopoverSelect.displayName = "PopoverSelect";
export default PopoverSelect;
